import { TableCell } from "@amzn/meridian/table";
import Text from "@amzn/meridian/text";
import React from "react";
import { useAppSelector } from "src/store/store";
import { AuditField } from "src/store/auditSlice";
import { isAnswerMatch, isFieldMultiSelected } from "src/components/pages/audit/helpers";
import { getAnswersSeparatedByComma } from "src/components/shared/groundTruth/reviewTable/helpers";
import { Row } from "@amzn/meridian";

interface AuditAnswerCellsProps {
  isBlind: boolean;
  randomizedOrder: boolean;
  auditField: AuditField;
  index: number;
}

const AuditAnswerCells: React.FC<AuditAnswerCellsProps> = ({
  isBlind,
  randomizedOrder,
  auditField,
  index,
}) => {
  const { selectedModel } = useAppSelector((state) => state.modelSlice);
  const { selectedAuditData } = useAppSelector((state) => state.auditSlice);

  // Check if this field has smart assistant data
  const smartAssistantField = selectedAuditData.smartAssistantData?.fieldData.find(
    (field) => field.fieldName === auditField.fieldName,
  );
  const aiOutput = smartAssistantField
    ? smartAssistantField.suggestedValues.join(", ")
    : getAnswersSeparatedByComma(auditField.llmAnswer);
  const aiSource = smartAssistantField ? "EHS" : "LLM";

  const textColor = isAnswerMatch(
    auditField.austinAnswer,
    aiOutput,
    isFieldMultiSelected(auditField, selectedModel),
  )
    ? "primary"
    : "error";
  if (isBlind && randomizedOrder) {
    return (
      <>
        <TableCell width={"20%"}>
          <Row spacing="200" alignmentVertical="center">
            <Text
              color={textColor}
              data-cy={`audit-data-review-view-${index}-row__llm-output_text`}
            >
              {aiOutput}
            </Text>
          </Row>
        </TableCell>
        <TableCell width={"20%"}>
          <Text color={textColor}>{getAnswersSeparatedByComma(auditField.austinAnswer)}</Text>
        </TableCell>
      </>
    );
  }

  return (
    <>
      <TableCell width={"20%"}>
        <Text color={textColor}>{getAnswersSeparatedByComma(auditField.austinAnswer)}</Text>
      </TableCell>
      <TableCell width={"20%"}>
        <Row spacing="200" alignmentVertical="center">
          <Text color={textColor} data-cy={`audit-data-review-view-${index}-row__llm-output_text`}>
            {aiOutput}
          </Text>
        </Row>
      </TableCell>
    </>
  );
};

export default AuditAnswerCells;
